import { configureStore, combineReducers } from "@reduxjs/toolkit"

import {
	loadPersistedState,
	persistStore as runPersistor,
} from "@/lib/reduxPersist"

import userPreferencesReducer from "./features/userPreferencesSlice"
import investmentsOverviewReducer from "./features/investmentsOverview/slice"
import paymentPatchesReducer from "./features/energySupplierApproval/paymentPatchesSlice"

import { migrations } from "./migrations"

const rootReducer = combineReducers({
	userPreferences: userPreferencesReducer,
	investmentsOverview: investmentsOverviewReducer,
	paymentPatches: paymentPatchesReducer,
})

const PERSIST_VERSION = 9
const PERSIST_KEY = "root"

// Apply each migration step from `(fromVersion + 1)` up to `toVersion`. Mirrors
// redux-persist's `createMigrate` semantics so existing state migrates cleanly.
function migrate(state: unknown, fromVersion: number): unknown {
	let next = state
	for (let v = fromVersion + 1; v <= PERSIST_VERSION; v++) {
		const step = migrations[v as keyof typeof migrations]
		if (step) next = step(next)
	}
	return next
}

type RootState = ReturnType<typeof rootReducer>

const preloadedState = loadPersistedState<RootState>({
	key: PERSIST_KEY,
	version: PERSIST_VERSION,
	migrate,
})

export const store = configureStore({
	reducer: rootReducer,
	preloadedState: preloadedState as Parameters<typeof rootReducer>[0],
})

export const persistor = runPersistor(store, {
	key: PERSIST_KEY,
	version: PERSIST_VERSION,
})
